import React from 'react';
import { Link } from 'react-router-dom';

const Awards = () => {
  const cardStyle = {
    backgroundColor: '#ffffff',
    padding: '2rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    transition: 'all 0.3s ease',
    height: '100%',
    marginBottom: '1.5rem'
  };

  const cardHoverStyle = {
    transform: 'translateY(-2px)',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
  };

  const sectionStyle = {
    marginBottom: '3rem',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '16px',
    border: '1px solid #e2e8f0'
  };

  return (
    <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      <div style={{textAlign: 'center', marginBottom: '3rem'}}>
        <h1 className="page-title" style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '1rem'}}>
          🏆 EBTA Awards
        </h1>
        <p className="page-subtitle" style={{fontSize: '1.2rem', color: '#64748b', maxWidth: '600px', margin: '0 auto'}}>
          Recognizing excellence and distinguished contributions in solution-focused brief therapy
        </p>
      </div>

      {/* Introduction */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🎖️</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Annual EBTA Awards</h2>
        </div>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6'}}>
          EBTA grants three awards every year to recognize outstanding contributions to the field of solution-focused brief therapy: the Research Grant, the Award for Lifelong Contribution, and the Award for Inspiring Thinking.
        </p>
      </div>

      {/* Three Awards */}
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '2rem', marginBottom: '3rem'}}>
        
        {/* Research Grant Award */}
        <Link 
          to="/research/grant"
          style={{...cardStyle, backgroundColor: '#f0f9ff', border: '1px solid #bfdbfe'}}
          onMouseEnter={(e) => {
            Object.assign(e.target.style, cardHoverStyle);
            e.target.style.backgroundColor = '#dbeafe';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = cardStyle.boxShadow;
            e.target.style.backgroundColor = '#f0f9ff';
          }}
        >
          <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1.5rem'}}>
            <div style={{fontSize: '2.5rem', marginRight: '1rem', color: '#2563eb'}}>💰</div>
            <div>
              <h3 style={{color: '#2563eb', marginBottom: '0.5rem', fontSize: '1.4rem', fontWeight: '600'}}>
                EBTA Research Grant
              </h3>
              <div style={{fontSize: '1.2rem', fontWeight: '600', color: '#1e40af'}}>€3,500</div>
            </div>
          </div>
          <p style={{color: '#6b7280', lineHeight: '1.6', marginBottom: '1rem'}}>
            Annual research grant supporting innovative research projects in solution-focused brief therapy. 
            Applications are reviewed by the EBTA Research Task Group.
          </p>
          <div style={{display: 'flex', alignItems: 'center', color: '#2563eb', fontWeight: '500'}}>
            <span>Apply for Research Grant</span>
            <span style={{marginLeft: '0.5rem'}}>→</span>
          </div>
        </Link>

        {/* Award for Lifelong Contribution */}
        <div style={{...cardStyle, backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0'}}>
          <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1.5rem'}}>
            <div style={{fontSize: '2.5rem', marginRight: '1rem', color: '#059669'}}>🌟</div>
            <div>
              <h3 style={{color: '#166534', marginBottom: '0.5rem', fontSize: '1.4rem', fontWeight: '600'}}>
                Award for Lifelong Contribution to the Solution Focused Community
              </h3>
              <div style={{fontSize: '0.9rem', color: '#6b7280', fontStyle: 'italic'}}>Awarded by EBTA Board</div>
            </div>
          </div>
          <p style={{color: '#6b7280', lineHeight: '1.6', marginBottom: '1rem'}}>
            This award recognizes individuals who have demonstrated sustained, lifelong commitment and exceptional contributions
            to the solution-focused community, advancing the approach and its values over many years.
          </p>
          <div style={{backgroundColor: '#dcfce7', padding: '0.75rem', borderRadius: '6px', fontSize: '0.9rem', color: '#166534'}}>
            <strong>Awarded annually by EBTA Board</strong>
          </div>
        </div>

        {/* Award for Inspiring Thinking */}
        <div style={{...cardStyle, backgroundColor: '#fdf4ff', border: '1px solid #e9d5ff'}}>
          <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '1.5rem'}}>
            <div style={{fontSize: '2.5rem', marginRight: '1rem', color: '#7c3aed'}}>🎓</div>
            <div>
              <h3 style={{color: '#7c2d12', marginBottom: '0.5rem', fontSize: '1.4rem', fontWeight: '600'}}>
                Award for Inspiring Thinking and Contribution to the Solution Focused Community
              </h3>
              <div style={{fontSize: '0.9rem', color: '#6b7280', fontStyle: 'italic'}}>Awarded by EBTA Board</div>
            </div>
          </div>
          <p style={{color: '#6b7280', lineHeight: '1.6', marginBottom: '1rem'}}>
            This award honors individuals or organizations whose innovative thinking, contributions, and leadership have
            inspired and enriched the solution-focused community, advancing the field's development and reach.
          </p>
          <div style={{backgroundColor: '#f3e8ff', padding: '0.75rem', borderRadius: '6px', fontSize: '0.9rem', color: '#7c2d12'}}>
            <strong>Awarded annually by EBTA Board</strong>
          </div>
        </div>
      </div>

      {/* Awards History Section */}
      <div style={sectionStyle} id="awards-history">
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>📚</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Awards History</h2>
        </div>
        
        <div style={{marginBottom: '2rem'}}>
          <h3 style={{color: '#2563eb', fontSize: '1.3rem', fontWeight: '600', marginBottom: '1rem'}}>
            🔬 Research Grant Awards (2001-2025)
          </h3>
          <p style={{color: '#64748b', marginBottom: '1rem'}}>
            Since 2001, EBTA has awarded 25 research grants totaling over €87,500 to support innovative research in solution-focused brief therapy.
          </p>
          <a
            href="/research/grant#awards-history"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#2563eb',
              color: 'white',
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '500',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#1d4ed8'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#2563eb'}
          >
            <span style={{marginRight: '0.5rem'}}>📄</span>
            View Complete Research Grant History
          </a>
        </div>

        <div>
          <h3 style={{color: '#7c3aed', fontSize: '1.3rem', fontWeight: '600', marginBottom: '1rem'}}>
            🏆 History of EBTA Awards for Contributions to SF Community and Thinking
          </h3>
          <p style={{color: '#64748b', marginBottom: '1.5rem', lineHeight: '1.6'}}>
            Since 2025 EBTA has introduced two annual awards: Award for Lifelong contribution to the Solution Focused community and Award for Inspiring Thinking and Contribution to the Solution Focused Community.
          </p>
          
          <div style={{
            background: '#fdf4ff',
            padding: '1.5rem',
            borderRadius: '8px',
            border: '1px solid #e9d5ff',
            marginBottom: '2rem'
          }}>
            <h4 style={{color: '#7c2d12', fontSize: '1.1rem', fontWeight: '600', marginBottom: '1rem'}}>
              🌟 2025 Awards - New Structure
            </h4>
            <div style={{display: 'grid', gap: '0.75rem', marginBottom: '1rem'}}>
              <div style={{padding: '0.75rem', backgroundColor: '#f3e8ff', borderRadius: '6px', border: '1px solid #e9d5ff'}}>
                <div style={{fontWeight: '600', color: '#7c2d12', marginBottom: '0.25rem'}}>
                  Award for Lifelong Contribution to the Solution Focused Community
                </div>
                <div style={{color: '#7c2d12'}}>Ursula Buehlmann, Switzerland</div>
              </div>
              <div style={{padding: '0.75rem', backgroundColor: '#f3e8ff', borderRadius: '6px', border: '1px solid #e9d5ff'}}>
                <div style={{fontWeight: '600', color: '#7c2d12', marginBottom: '0.25rem'}}>
                  Award for Inspiring Thinking and Contribution to the Solution Focused Community
                </div>
                <div style={{color: '#7c2d12'}}>Family Based Solutions</div>
              </div>
            </div>
          </div>

          <div style={{
            background: '#fdf4ff',
            padding: '1.5rem',
            borderRadius: '8px',
            border: '1px solid #e9d5ff'
          }}>
            <h4 style={{color: '#7c2d12', fontSize: '1.1rem', fontWeight: '600', marginBottom: '1rem'}}>
              📚 Historical Awards (2011-2024)
            </h4>
            <div style={{display: 'grid', gap: '0.75rem'}}>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2024</span>
                <span style={{color: '#7c2d12'}}>Ferdinand Wolf, Austria</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2023</span>
                <span style={{color: '#7c2d12'}}>Marie-Christine Cabie, France</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2022</span>
                <span style={{color: '#7c2d12'}}>Michael Klingenstierna Hjerth, Sweden</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2019</span>
                <span style={{color: '#7c2d12'}}>Jacek Lelonkiewicz, Poland</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2018</span>
                <span style={{color: '#7c2d12'}}>Peter Sundman, Finland</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2017</span>
                <span style={{color: '#7c2d12'}}>Mark Beyebach, Spain</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2016</span>
                <span style={{color: '#7c2d12'}}>Therese Steiner, Switzerland</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2015</span>
                <span style={{color: '#7c2d12'}}>NIK, Bremen, Germany</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2014</span>
                <span style={{color: '#7c2d12'}}>Harry Korman, Sweden</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2013</span>
                <span style={{color: '#7c2d12'}}>Luc Isebaert, Belgium</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2012</span>
                <span style={{color: '#7c2d12'}}>BRIEF, London, UK</span>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f3e8ff', borderRadius: '4px'}}>
                <span style={{fontWeight: '600', color: '#7c2d12'}}>2011</span>
                <span style={{color: '#7c2d12'}}>Alasdair Macdonald, UK</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div style={{...sectionStyle, backgroundColor: '#f1f5f9', textAlign: 'center'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🚀</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Get Involved</h2>
        </div>
        <p style={{fontSize: '1.1rem', color: '#64748b', marginBottom: '2rem', maxWidth: '600px', margin: '0 auto 2rem'}}>
          Contribute to the advancement of solution-focused brief therapy through research and practice.
        </p>
        <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center'}}>
          <Link 
            to="/research/grant"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#2563eb',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>💰</span>
            Apply for Research Grant
          </Link>
          <Link 
            to="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#059669',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#047857';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>📧</span>
            Contact EBTA
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Awards;
